import { render, staticRenderFns } from "./message_queue_create.vue?vue&type=template&id=06744a84&scoped=true"
import script from "./message_queue_create.vue?vue&type=script&lang=ts"
export * from "./message_queue_create.vue?vue&type=script&lang=ts"
import style0 from "./message_queue_create.vue?vue&type=style&index=0&id=06744a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06744a84",
  null
  
)

export default component.exports